export default __webpack_public_path__ + "resources/icons/n120-1375.png";